import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

export const BG_OPTIONS = [
  {
    id: "sunflower-real",
    label: "Girassol Real",
    description: "Foto de um girassol autêntico ao lado da tela.",
    url: "https://images.unsplash.com/photo-1470509037663-253afd7f0f51?auto=format&fit=crop&w=1200&q=85",
    thumb: "https://images.unsplash.com/photo-1470509037663-253afd7f0f51?auto=format&fit=crop&w=400&q=70",
  },
  {
    id: "sunflower-close",
    label: "Girassol Close-up",
    description: "Detalhe da flor com pétalas em destaque.",
    url: "/themes/sunflower-close.jpg",
    thumb: "/themes/sunflower-close-thumb.jpg",
  },
  {
    id: "sunflower-field",
    label: "Campo de Girassóis",
    description: "Campo vasto ao fundo, para o site inteiro.",
    url: "https://images.unsplash.com/photo-1597848212624-a19eb35e2651?auto=format&fit=crop&w=1600&q=85",
    thumb: "https://images.unsplash.com/photo-1597848212624-a19eb35e2651?auto=format&fit=crop&w=400&q=70",
  },
  {
    id: "sunflower-bouquet",
    label: "Buquê de Girassol",
    description: "Buquê delicado — combina com estúdio boutique.",
    url: "/themes/sunflower-bouquet.jpg",
    thumb: "/themes/sunflower-bouquet-thumb.jpg",
  },
  {
    id: "sunflower-illustration",
    label: "Ilustração Sutil (SVG)",
    description: "Ilustração dourada bem discreta (original).",
    url: null,
    thumb: null,
  },
  {
    id: "none",
    label: "Sem imagem",
    description: "Deixe o fundo limpo, apenas creme.",
    url: null,
    thumb: null,
  },
];

const DEFAULT_THEME = { bg_style: "sunflower-real", bg_opacity: 18, bg_position: "right" };
const ThemeCtx = createContext({ theme: DEFAULT_THEME, refresh: () => {} });

function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  const opt = BG_OPTIONS.find(o => o.id === theme.bg_style) || BG_OPTIONS[0];
  root.style.setProperty("--bg-image", opt.url ? `url("${opt.url}")` : "none");
  root.style.setProperty("--bg-opacity", String((theme.bg_opacity || 0) / 100));
  root.style.setProperty("--bg-position", theme.bg_position || "right");
  root.setAttribute("data-bg-style", theme.bg_style);
  root.setAttribute("data-bg-position", theme.bg_position);
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(DEFAULT_THEME);

  const refresh = useCallback(() => {
    api.get("/theme").then(r => {
      const merged = { ...DEFAULT_THEME, ...(r.data || {}) };
      setTheme(merged);
      applyTheme(merged);
    }).catch(() => applyTheme(DEFAULT_THEME));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <ThemeCtx.Provider value={{ theme, refresh, setTheme: (t)=>{ setTheme(t); applyTheme(t); } }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
